import { Typography } from 'antd';
import React from 'react';
import DashboardWelcomeViewCards from './Cards';

const DashboardWelcomeView: React.FC = () => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '24px',
        }}
      >
        <Typography.Title level={2} style={{ margin: 0 }}>
          Seja Bem-vindo!
        </Typography.Title>

        <Typography.Text>
          Estes são os principais módulos do sistema.
        </Typography.Text>
      </div>

      <DashboardWelcomeViewCards />
    </>
  );
};

export default DashboardWelcomeView;
